<!--
 * @Descripttion: 地块信息-垂直展示（托管）
 * @Author: juanjuanhui
 * @Date: 2022-03-23 14:00:45
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-04-15 11:40:16
-->
<template>
  <div class="content">
    <ul class="list">
      <li class="item">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaibianhao"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块编号</p>
            <p class="name">{{ curLandInfo.croplandId }}</p>
          </div>
        </div>
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaimianji"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块面积</p>
            <p class="name">{{ curLandInfo.croplandArea }}亩</p>
          </div>
        </div>
      </li>
      <li class="item">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-dikuaizhouchang"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块周长</p>
            <p class="name">{{ curLandInfo.croplandPerimeter }}米</p>
          </div>
        </div>
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-tudiliuchufang"></i>
          </div>
          <div class="right-side">
            <p class="tit">土地流出方</p>
            <p class="name">{{ curLandInfo.transferName }}</p>
          </div>
        </div>
      </li>
      <li class="item item-last">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-liuchufangdianhua"></i>
          </div>
          <div class="right-side">
            <p class="tit">流出方电话</p>
            <p class="name">{{ curLandInfo.transferMobile }}</p>
          </div>
        </div>
      </li>
      <li class="item item-last">
        <div class="cell">
          <div class="left-side">
            <i class="iconfont icon-a-1dikuaiweizhi"></i>
          </div>
          <div class="right-side">
            <p class="tit">地块位置</p>
            <p class="name">{{ curLandInfo.address }}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MapLandInfoHorizontal",
  data() {
    return {};
  },
  props: {
    curLandInfo: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  margin-top: 15px;
  .item {
    display: flex;
    border-bottom: 1px solid #3d403b;
    .cell {
      display: flex;
      width: 50%;
      padding: 5px 10px;
      box-sizing: border-box;
      &:nth-child(2) {
        border-left: 1px solid #3d403b;
      }
      .left-side {
        margin: 10px 10px 10px 0;
        i {
          color: #2ac9cf;
          font-size: 32px;
        }
      }
      .right-side {
        flex: 1;
        margin: 10px 0;
        .tit {
          color: #2ac9cf;
          font-size: 14px;
        }
        .name {
          color: #d0e7e8;
        }
      }
    }
    &:first-child {
      border-top: 1px solid #3d403b;
    }
    &.item-last {
      .cell {
        width: 100%;
      }
    }
  }
}
</style>
